import type { DataType, DataTypeNameGeneral } from '~/common/model/api/common';

import { DATA_TYPE_GENERAL_NAMES } from '~/common/constants/feature/settings/batch-type-library';

/**
 * Get DataType from ListFieldType.
 *
 * @param {DataType['name']} fieldTypeName FieldType name.
 *
 * @returns {DataTypeNameGeneral} DataType of ListFieldType.
 */
export function getListDataType(fieldTypeName: DataType['name']): DataTypeNameGeneral | false {
  const listTypeResult = /^list\.(.+?)$/.exec(fieldTypeName);
  if (listTypeResult) {
    const typeName = listTypeResult[1];
    if (typeName && DATA_TYPE_GENERAL_NAMES.includes(typeName)) {
      return typeName;
    }
  }

  return false;
}
